export enum JobStatusEnum {
  NotStarted = "NotStarted",
  Running = "Running",
  Succeeded = "Succeeded",
  Failed = "Failed",
}
